import { createSlice } from '@reduxjs/toolkit'

type InitialState = {
  fileHistoryData: []
  fileHistorySummary: {}
  rowCount: number
}

const initialState: InitialState = {
  fileHistoryData: [],
  fileHistorySummary: {},
  rowCount: 0,
}

export const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    getFileHistoryDetail: (state, action) => {
      const { fileHistoryData, rowCount } = action.payload
      state.fileHistoryData = fileHistoryData
      state.rowCount = rowCount
    },
    getSummary: (state, action) => {
      const { summary } = action.payload
      state.fileHistorySummary = summary
    },
  },
})

// Action creators are generated for each case reducer function
export const { getFileHistoryDetail, getSummary } = homeSlice.actions

export default homeSlice.reducer
